module.exports = __webpack_public_path__ + "img/new-year-scooter.104325df.svg";